import { HeroNumberWithFields } from "@aidkitorg/types/lib/survey";

export const useApplicantCountFormState = () => {

  const buildApplicantCountObject = (): HeroNumberWithFields => {
    return {
      kind: 'Hero Number',
      title: 'Total Applicants',
      summary: {
        kind: 'Count'
      },
      useCommas: true,
    };
  };

  const isFormStateValid = true;

  return {
    buildApplicantCountObject,
    isFormStateValid
  };
};